export default "__VITE_ASSET__vtTalS7O__"